import fetchWithAuth from "../middlewares/fetchWithAuth";
import { API_BASE_URL } from "../config";

const API_URL = `${API_BASE_URL}/clasificaciones`;

// Función para obtener las competiciones
export const getClasificacionesGrupoTemporada = async (
  idTemporada,
  idGrupo,
  navigate
) => {
  try {
    const response = await fetchWithAuth(
      `${API_URL}/${idGrupo}/${idTemporada}`,
      {
        method: "GET",
        cache: "no-store",
        headers: {
          "Content-Type": "application/json",
        },
      },
      navigate
    );

    if (response.ok) {
      const data = await response.json();
      return data;
    }

    throw new Error("Error al obtener las competiciones");
  } catch (error) {
    throw error;
  }
};
